import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Blueiaas from '@/components/BlueIaas.vue'
import Blueoffice from '@/components/BlueOffice.vue'
import Bluesolution from '@/components/BlueSolution.vue'
import BluesolutionU9 from '@/components/BlueSolution-U9.vue'
import BluesolutionCT01 from '@/components/BlueSolution-CT01.vue'
import Bluemanufacture from '@/components/BlueManufacture.vue'
import BlueiaasLX5HL101 from '@/components/Blueiaas-LX5-HL101.vue'
import BlueiaasLX5HS101 from '@/components/Blueiaas-LX5-HS101.vue'
import BlueiaasLX5HL302 from '@/components/Blueiaas-LX5-HL302.vue'
import BlueiaasLX5HS302 from '@/components/Blueiaas-LX5-HS302.vue'
import BlueiaasLX5HP302 from '@/components/Blueiaas-LX5-HP302.vue'
import BlueiaasLX5HL303 from '@/components/Blueiaas-LX5-HL303.vue'
import BlueiaasLX5HS303 from '@/components/Blueiaas-LX5-HS303.vue'
import BlueiaasLX5HP303 from '@/components/Blueiaas-LX5-HP303.vue'
import BlueiaasLX5ML011 from '@/components/Blueiaas-LX5-ML011.vue'
import BlueiaasLX5ML021 from '@/components/Blueiaas-LX5-ML021.vue'
import BlueiaasLX5ML022 from '@/components/Blueiaas-LX5-ML022.vue'
import BlueiaasLX5MP022 from '@/components/Blueiaas-LX5-MP022.vue'
import BlueiaasLX5ML023 from '@/components/Blueiaas-LX5-ML023.vue'

const routes = [
  {
    meta: { title: '首页' },
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    meta: { title: '首页' },
    path: '/Blueiaas',
    name: 'Blueiaas',
    component: Blueiaas
  },
  {
    title: '',
    path: '/Blueoffice',
    name: 'Blueoffice',
    component: Blueoffice
  },
  {
    title: '',
    path: '/Bluesolution',
    name: 'Bluesolution',
    component: Bluesolution
  },
  {
    title: '',
    path: '/Bluemanufacture',
    name: 'Bluemanufacture',
    component: Bluemanufacture
  },
  {
    title: '',
    path: '/Blueiaas-LX5-HL101',
    name: 'Blueiaas-LX5-HL101',
    component: BlueiaasLX5HL101
  },
  {
    title: '',
    path: '/Blueiaas-LX5-HS101',
    name: 'Blueiaas-LX5-HS101',
    component: BlueiaasLX5HS101
  },
  {
    title: '',
    path: '/Blueiaas-LX5-HL302',
    name: 'Blueiaas-LX5-HL302',
    component: BlueiaasLX5HL302
  },
  {
    title: '',
    path: '/Blueiaas-LX5-HS302',
    name: 'Blueiaas-LX5-HS302',
    component: BlueiaasLX5HS302
  },
  {
    title: '',
    path: '/Blueiaas-LX5-HP302',
    name: 'Blueiaas-LX5-HP302',
    component: BlueiaasLX5HP302
  },
  {
    title: '',
    path: '/Blueiaas-LX5-HL303',
    name: 'Blueiaas-LX5-HL303',
    component: BlueiaasLX5HL303
  },
  {
    title: '',
    path: '/Blueiaas-LX5-HS303',
    name: 'Blueiaas-LX5-HS303',
    component: BlueiaasLX5HS303
  },
  {
    title: '',
    path: '/Blueiaas-LX5-HP303',
    name: 'Blueiaas-LX5-HP303',
    component: BlueiaasLX5HP303
  },
  {
    title: '',
    path: '/Blueiaas-LX5-ML011',
    name: 'Blueiaas-LX5-ML011',
    component: BlueiaasLX5ML011
  },
  {
    title: '',
    path: '/Blueiaas-LX5-ML021',
    name: 'Blueiaas-LX5-ML021',
    component: BlueiaasLX5ML021
  },
  {
    title: '',
    path: '/Blueiaas-LX5-ML022',
    name: 'Blueiaas-LX5-ML022',
    component: BlueiaasLX5ML022
  },
  {
    title: '',
    path: '/Blueiaas-LX5-MP022',
    name: 'Blueiaas-LX5-MP022',
    component: BlueiaasLX5MP022
  },
  {
    title: '',
    path: '/Blueiaas-LX5-ML023',
    name: 'Blueiaas-LX5-ML023',
    component: BlueiaasLX5ML023
  },
  {
    title: '',
    path: '/BlueSolution-U9',
    name: 'BlueSolution-U9',
    component: BluesolutionU9
  },
  {
    title: '',
    path: '/BlueSolution-CT01',
    name: 'BlueSolution-CT01',
    component: BluesolutionCT01
  },
]

const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
